export default __webpack_public_path__ + "static/media/FOOD.1e5f8de5.png";